module.exports = __webpack_public_path__ + "static/media/arrow_v2.b045d77b.png";